import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';

const DealerNameOverride = ({ onChange, name }) =>
  (
    <TextField
      id="dealerName"
      label="Dealer Name"
      value={name}
      fullWidth
      onChange={(event) => onChange({ dealerName: event.target.value })}
    />
  );

DealerNameOverride.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func,
};

DealerNameOverride.defaultProps = {
  name: '',
};

export default DealerNameOverride;



// WEBPACK FOOTER //
// ./src/feed-overrides/components/DealerNameOverride.jsx